import Cookies from 'js-cookie';

export const isSignedIn = (): boolean => {
  return Boolean(Cookies.get('token'));
};
